/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TattooStatus {
    NONE = 'NONE',
    MINIMAL = 'MINIMAL',
    MODERATE = 'MODERATE',
}
